import { Factsheet_Effectiveness_Evaluation, File as GraphqlFile } from 'src/@types/graphql'
import { EvaluationFileItem } from 'src/screens/shared/evidence-of-effectiveness/EvidenceOfEffectivenessFilesGrid'

// maps a GraphQL evaluation and its associated file to an EvaluationFileItem
export const mapToEvaluationFileItem = (
  evaluation: Factsheet_Effectiveness_Evaluation,
  file: GraphqlFile | undefined,
): EvaluationFileItem => {
  const browserFile = createBrowserFile(file)

  return {
    id: evaluation.id,

    // file properties
    fileUUID: file?.uuid ?? null,
    file: browserFile,
    fileName: browserFile.name,

    // evaluation properties
    evaluationIndex: evaluation.evaluation_index,
    entityId: evaluation.id,
    name: evaluation.name,
    author: evaluation.author,
    yearPublication: evaluation.year_publication,
    publish: evaluation.publication_authorized,
  }
}

// creates a new EvaluationFileItem from a File object
export const createNewEvaluationFileItem = (file: File, evaluationIndex: number = 0): EvaluationFileItem => {
  return {
    id: Date.now() + evaluationIndex,
    fileName: file.name,
    fileUUID: null,
    entityId: null,
    evaluationIndex: evaluationIndex,
    name: '',
    yearPublication: null,
    publish: false,
    author: '',
    file: file,
  }
}

// updates an existing EvaluationFileItem with new values
export const updateEvaluationFileItem = (
  originalItem: EvaluationFileItem,
  newRow: Partial<EvaluationFileItem>,
): EvaluationFileItem => {
  return {
    ...originalItem,
    name: newRow.name ?? originalItem.name,
    author: newRow.author ?? originalItem.author,
    yearPublication: newRow.yearPublication ?? originalItem.yearPublication,
    publish: newRow.publish !== undefined ? newRow.publish : originalItem.publish,
  }
}

const createBrowserFile = (file: GraphqlFile | undefined): File => {
  if (file) {
    return new File([], file.file_name, {
      type: file.file_type,
      lastModified: new Date(file.upload_date).getTime(),
    })
  }

  const invalidFile = new File([], 'N/A', {
    type: 'application/octet-stream',
  })
  ;(invalidFile as any).isValid = false
  return invalidFile
}
